import { Node } from '@tiptap/core';

const PlaceholderDocNode = Node.create({
  name: "placeholderDoc",
  topnode: true,
  content: "block*"
});

export { PlaceholderDocNode };
//# sourceMappingURL=PlaceholderDoc.js.map
